import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import validationScheme, { FormContactDataType } from '@/features/forms/FormContato/validationScheme';
import { CONTACT_TYPES } from '@/features/forms/FormContato/data';
import { useFormContatoContext } from '@/features/forms/FormContato/context';
import useFeedbackHandler from '@/features/forms/hooks/useFeedbackHandler';
import { FORMS_ENDPOINT } from '@/helpers/browser';
import formPayloadParser, { FormPayloadDataType } from '@/features/forms/formPayloadParser';
import { trackFBPixel, trackGTMEvent, trackRDStation } from '@/utils/tracking';

export default function useFormMethods() {
  const { params, data } = useFormContatoContext();
  const { feedback, submitting, submitted, submitRequestHandler } = useFeedbackHandler();

  const methods = useForm<FormContactDataType>({
    resolver: zodResolver(validationScheme),
    defaultValues: {
      contactType: CONTACT_TYPES.VIAJANTE.value,
      companyName: '',
      subject: (params.subject === 'flight' && 'Passagens Aéreas') || 'Outros',

      // Subject=Travel
      origin: params.origin || '',
      destination: params.destination || '',
      dateDepart: '',
      dateReturn: '',
      paxNumber: '',
      //
      message: '',
      name: '',
      email: '',
      phone: '',
      subscribeNews: false,
      phoneData: {
        number: '',
        countryName: '',
        dialCode: '',
      },
    },
  });

  const { isValid } = methods.formState;
  const { reset } = methods;

  // const mock = () => new Promise((resolve) => setTimeout(resolve, 2000));
  const onSubmit = async (data: FormContactDataType) => {
    if (!isValid) {
      return;
    }

    const payload = formPayloadParser({ ...data } as FormPayloadDataType);

    submitRequestHandler(FORMS_ENDPOINT.form_contact, payload).then((done) => {
      console.log(`DONE`, done);
      if (done) {
        reset();
        // =====================
        // FORM EVENT TRACKING
        // =====================
        trackGTMEvent({ eventCategory: 'Form', eventAction: 'submit', eventLabel: 'form-contato' });
        trackRDStation('form-contato', payload);
        trackFBPixel('form-contato', 'Form Contato');
      }
    });
  };

  return {
    methods,
    feedback,
    submitting,
    submitted,
    onSubmit,
  };
}
